import { render, staticRenderFns } from "./ErrorMenu.vue?vue&type=template&id=61bb2752"
import script from "./ErrorMenu.vue?vue&type=script&lang=js"
export * from "./ErrorMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports